// extracted by mini-css-extract-plugin
module.exports = {"input":"Select-module--input--2uWQZ","error":"Select-module--error--LFr3z","label":"Select-module--label--fZ47P","required":"Select-module--required--hU4xo"};